import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { BiDataHook, BiEventType, ReferralType, } from '@wix/da-bi/pkg/constants';
import GiveBadgeIcon from '@wix/da-ds/pkg/Icons/24x24/GiveBadge';
import { getDeviationResourceType } from '../../../DeviationViews/_helpers';
import ActionBarIcon from '../../_partials/ActionBarIcon';
import ActionBarButton from '../../_partials/items/ActionBarButton';
import ActionBarButtonRestricted from '../../_partials/ActionBarButtonRestricted';
import { useRestrictToLoggedIn } from '../../../utils/hooks/useRestrictToLoggedIn';
var AwardBadgeButton = function (_a) {
    var deviation = _a.deviation, limitedBadgesPromo = _a.limitedBadgesPromo, onAwardClick = _a.onAwardClick;
    var t = useTranslation().t;
    var restrictToLoggedIn = useRestrictToLoggedIn().restrictToLoggedIn;
    var typeId = getDeviationResourceType(deviation);
    var clickHandler = useCallback(function () {
        onAwardClick(deviation);
    }, [onAwardClick, deviation]);
    var tooltip = t('actionbar.awardBadge');
    return (React.createElement(ActionBarButtonRestricted, { subscribersOnly: true, deviation: deviation, tooltip: tooltip, button: React.createElement(ActionBarButton, { onClick: restrictToLoggedIn(ReferralType.AWARD_BADGE, clickHandler), "data-hook": BiDataHook.DEVIATION_AWARD_BADGE_BUTTON, "aria-label": tooltip, biData: {
                evid: BiEventType.GIVE_BADGE_AWARD,
                sectionname: 'deviation',
                typeid: typeId,
                itemid: deviation.deviationId,
            } }, (limitedBadgesPromo === null || limitedBadgesPromo === void 0 ? void 0 : limitedBadgesPromo.campaignIconOverride) ? (React.createElement("img", { src: limitedBadgesPromo.campaignIconOverride, width: "24", height: "24", alt: "" })) : (React.createElement(ActionBarIcon, { icon: GiveBadgeIcon }))) }));
};
AwardBadgeButton.displayName = 'AwardBadgeButton';
export default AwardBadgeButton;
//# sourceMappingURL=AwardBadgeButton.js.map